export default "__VITE_ASSET__3okI2u_f__"